import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 350px;
  width: 100%;
  color: #fff;
  margin: 15px;
  font-size: 4em;
`;